import axios from 'shop/lib/axios'
import API from 'shared/lib/api'

export const fetchDeliveryOptionsRequest = ({ cartId, deliveryAddress }) => {
  return API.post('delivery_options', {
    apiVersion: 'boomerang',
    filter: {
      cart_id: cartId,
      delivery: {
        address: deliveryAddress
      }
    },
    include: 'cart'
  })
}

export const fetchUserAddressesRequest = () => {
  const url = window.booqableOptions?.apiURL ?
    `${window.booqableOptions?.apiURL}/user_addresses` :
    '/user_addresses'

  return axios.get(url)
}
